import {UIState} from "../../../data/UIState";
import {observer} from "mobx-react";
import * as React from "react";
import {action, observable} from "mobx";
import {NavAvatar} from "../../nav/NavAvatar";

import './CommentReplyAdd.pcss';
import {Alert} from "../../../data/Alert";
import { MentionsInput, Mention } from 'react-mentions'
import {IMentionUser} from "shared/IMentionUser";
import * as theme from 'theme.js';
import {handleSpacePressed} from "utils";


interface Props {
  originalCommenter:string;
  addReply:(reply:string)=>Promise<void>;
  possibleUsersToMention:IMentionUser[]
}

@observer
export class CommentReplyAdd extends React.Component<Props> {
  @observable active = false;
  @observable replying = false;
  @observable reply:string = '';
  mentionsInputRef;
  @observable mentionedUsers:IMentionUser[] = [];

  constructor(props:Props) {
    super(props);
    this.mentionsInputRef = React.createRef();
  }

  @action toggleActive = () => {
    if(!this.replying) {
      if (this.active) {
        this.clear();
      } else {
        this.active = true;
        setTimeout(()=>{
          if(this.mentionsInputRef.current) {
            this.mentionsInputRef.current.inputElement.focus()
          }
        }, 10);
      }
    }
  }

  @action handleAddReply = () => {
    if(!this.replying) {
      this.replying = true;
      this.props.addReply(this.reply)
      .then(() => {
        UIState.setAriaLiveAnnouncement("Reply posted.");
        this.clear();
        this.replying = false;
      })
      .catch((err) => {
        this.replying = false;
        console.log(err);
        Alert.alert("Failed to submit reply! Please make sure that you are connected to the Internet and try again.")
      });
    }
  }

  @action clear = () => {
    //this.textareaRef.current.innerHTML = '';
    this.reply = '';
    this.active = false;
  }

  render(){
    return (
        <div className={`comment-reply-add${this.active?' active':''}`}>
          {this.active ?
            <>
              <h3 className={'level3'}>Reply to {this.props.originalCommenter}</h3>
              <div className={'cra-form'}>
                <div className={"craf-avatar"}>
                  <NavAvatar alt={""}  user={UIState.user} variant={'xsmall'} />
                </div>
                <div className={"craf-inputs"}>
                  <MentionsInput
                    ref={this.mentionsInputRef}
                    placeholder={"enter a reply..."}
                    className={"mentions-input"}
                    style={this.active?styleMentionsInputActive:styleMentionsInput}
                    value={this.reply}
                    onChange={action((event, newValue, newPlainValue, mentions)=>{
                      this.reply = event.target.value;
                      this.mentionedUsers = mentions;
                    })}
                    onFocus={(event)=>{
                      this.active = true;
                      if(!this.replying) {
                        this.reply = event.currentTarget.textContent?event.currentTarget.textContent:'';
                      }
                    }}
                  >
                    <Mention
                      style={styleMention}
                      trigger="@"
                      data={this.props.possibleUsersToMention}
                      renderSuggestion={(suggestion, search, highlightedDisplay) => (
                        <div className="user">{highlightedDisplay}</div>
                      )}
                    />
                  </MentionsInput>


                  <div className={"cra-actions"}>
                    <a tabIndex={0} role={"button"} className="cra-btn reply three-band-focus"
                       onKeyDown={(e)=>{ handleSpacePressed(e, this.handleAddReply);}}
                       onClick={this.handleAddReply} aria-label={"Reply"}><span aria-hidden>Reply</span></a>
                    <a tabIndex={0} role={"button"} className="cra-btn cancel"
                       onKeyDown={(e)=>{ handleSpacePressed(e, this.toggleActive);}}
                       onClick={this.toggleActive} aria-label={"Cancel reply"}><span aria-hidden>Cancel</span></a>
                  </div>
                </div>

              </div>
            </>
          :
            <a role={"button"} href={"#"} className={"cra-reply"}
               onClick={this.toggleActive}
               onKeyDown={(e)=>{ handleSpacePressed(e, this.toggleActive);}}
               aria-label={`Reply to ${this.props.originalCommenter}`}>Reply</a>
          }
        </div>
    );
  }

}



const styleMentionsInput = {
  control: {
  },

  '&multiLine': {
    control: {
    },
    highlighter: {
    },
    input: {
    },
  },

  suggestions: {
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
    },
    item: {
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: '#cee4e5',

      },
    },
  },
}


const styleMentionsInputActive = {
  control: {
    resize: 'none',
    borderColor: theme.EgyptianBlue,
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
    color: theme.CharcoalAAA,
    padding: '8px',
    border: `1px solid ${theme.EgyptianBlue}`,
    borderRadius: '8px',
    minHeight: '72px',
  },

  '&multiLine': {
    control: {
    },
    highlighter: {
    },
    input: {
      resize: 'none',
      borderColor: theme.EgyptianBlue,
      fontFamily: 'Rubik',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '16px',
      color: theme.CharcoalAAA,
      padding: '8px',
      border: '1px solid transparent',
      minHeight: '72px',
    },
  },

  suggestions: {
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
    },
    item: {
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: '#cee4e5',
      },
    },
  },
}

const styleMention = {
  borderRadius:'4px',
  background: '#cee4e5',
}
